const validNumber = value => typeof value === 'number' && Number.isFinite(value) && value >= 0;

export const getGeminiUsageLimits = (usage, receivedAt = Date.now()) => {
  return [['session', usage?.five_hour], ['weekly_all', usage?.weekly]].flatMap(([kind, period]) => {
    if (!validNumber(period?.used_percent)) return [];
    // Prefer the absolute server timestamp. Anchor a relative fallback once at receipt,
    // so rendering or countdown ticks never move the reset deadline forward.
    const resetMs = validNumber(period.reset_at_ts) && period.reset_at_ts > 0
      ? period.reset_at_ts * 1000
      : validNumber(period.reset_in) ? receivedAt + period.reset_in * 1000 : NaN;
    const date = new Date(resetMs);
    return [{
      kind,
      percent: period.used_percent,
      resetsAt: Number.isFinite(date.getTime()) ? date.toISOString() : null,
    }];
  });
};
